import type { ManlyProfile } from "../profile";
import { VERDICT_META, PLAN_FOCUS } from "../copy";

export function ResultPage({
  profile, goal, onNext,
}: { profile: ManlyProfile; goal: string; onNext: () => void }) {
  const meta = VERDICT_META[profile.verdict];
  const focus = PLAN_FOCUS[goal] ?? PLAN_FOCUS.fresh;
  return (
    <>
      <div className="qk-manly-verdict">
        <div className="qk-manly-kicker">His Odor Profile</div>
        <div className="qk-manly-verdict-label">{profile.verdict}</div>
        <p>{profile.assessment}</p>
      </div>

      <div>
        <div
          className="qk-manly-meter-track"
          role="img"
          aria-label={`${profile.verdict}: ${meta.line}`}
        >
          <div className="qk-manly-meter-mark" style={{ left: meta.pos }} aria-hidden="true" />
        </div>
        <div className="qk-manly-meter-ends"><span>Early</span><span>Entrenched</span></div>
      </div>

      {/* Root causes carry a plain-language decode: the labels alone read as jargon. */}
      <div className="qk-manly-causes">
        <div className="qk-manly-cause">
          <div className="qk-manly-tag">Primary root cause</div>
          <h3>{profile.primary.name}</h3>
          <p>{profile.primary.copy}</p>
        </div>
        <div className="qk-manly-cause">
          <div className="qk-manly-tag">Secondary root cause</div>
          <h3>{profile.secondary.name}</h3>
          <p>{profile.secondary.copy}</p>
        </div>
      </div>

      <div className="qk-manly-stats">
        <div className="qk-manly-cause">
          <div className="qk-manly-tag">Daily chemical load</div>
          <h3>{profile.chem.level}</h3>
        </div>
        <div className="qk-manly-cause">
          <div className="qk-manly-tag">Plan focus</div>
          <h3>{focus}</h3>
        </div>
      </div>

      {/* Absolution only. Never claims a body wash causes or cures mood. Kept
          distinct from the fuller product-page note (different copy, same rule). */}
      {profile.mood && (
        <p className="qk-manly-note">
          Mood and energy are puberty doing its job, not something a body wash causes or
          cures. The chemical load is the one variable you can remove today.
        </p>
      )}

      <button type="button" className="qk-cta" onClick={onNext}>See his projection</button>
    </>
  );
}
